// Copyright (c) Move Closer 2022.

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const DictionaryServiceType = Symbol.for('IDictionaryServiceType')

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export interface ShipmentRegion {
  id: number
  code: string
  name: string
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export interface CountryData {
  availableRegions: ShipmentRegion[] | null
  fullNameLocale: string
  fullNameEnglish: string
  id: string
  twoLetterAbbreviation: string
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl> (original)
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (edited)
 */
export interface IDictionaryService {
  /**
   * Gets countries.
   */
  countries: CountryData[]

  /**
   * Fetches the countries.
   */
  loadCountries (): Promise<void>
}
